<template>
  <footer class="app-footer" :class="{'app-footer--mobile': deviceType === 'mobile'}">
    <div class="app-footer__container">
      <div class="app-footer__main">
        <div class="app-footer__info">
          <div class="app-footer__logo-box">
            <img :src="domainConfig?.['siteIcon']" alt="Logo" class="app-footer__logo-img">
            <span class="app-footer__logo-text">{{domainConfig?.['siteName']}}</span>
          </div>
          <p class="app-footer__desc" v-html="domainConfig?.['ABOUTUS']"></p>
        </div>
        <div class="app-footer__links-section">
          <h4 class="app-footer__section-title">RESOURCES</h4>
          <div class="app-footer__links">
            <a :href="getFooterLink('/about')">About Us</a>
            <a :href="getFooterLink('/terms-of-services')">Terms of Services</a>
            <a :href="getFooterLink('/privacy-policy')">Privacy Policy</a>
            <a :href="getFooterLink('/disclaimer')">Disclaimer</a>
          </div>
        </div>
        <div class="app-footer__contact">
          <h4 class="app-footer__section-title">CONTACT US</h4>
          <a :href="`mailto:${domainConfig['IAMEMAIL']}`"
            class="app-footer__email">{{ domainConfig?.['IAMEMAIL'] }}</a>
        </div>
        <div class="app-footer__social">
          <h4 class="app-footer__section-title">SHARE WITH</h4>
          <div class="app-footer__social-icons">
            <a href="javascript:void(0)" class="app-footer__social-btn" @click="showToast"><img
                src="@/assets/tiktok.png"></a>
            <a href="javascript:void(0)" class="app-footer__social-btn" @click="showToast"><img
                src="@/assets/twitter.png"></a>
            <a href="javascript:void(0)" class="app-footer__social-btn" @click="showToast"><img
                src="@/assets/facebook.png"></a>
            <a href="javascript:void(0)" class="app-footer__social-btn" @click="showToast"><img
                src="@/assets/instagram.png"></a>
          </div>
        </div>
      </div>
      <div class="app-footer__divider"></div>
      <div class="app-footer__bottom">
        <p class="app-footer__copyright">Copyright © 2026 {{domainConfig?.['siteName']}}. All Rights
          Reserved.</p>
      </div>
    </div>

    <!-- Toast 提示 -->
    <div class="app-footer__toast" v-if="showToastMessage">
      <div class="app-footer__toast-content">
        to be continue
      </div>
    </div>

  </footer>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'AppFooter',
  data () {
    return {
      showToastMessage: false,
      toastTimer: null
    }
  },
  computed: {
    ...mapGetters({
      deviceType: 'deviceType',
      domainConfig: 'domainConfig'
    })
  },
  methods: {
    // 获取页脚链接（支持channel参数）
    getFooterLink (link) {
      // // 获取当前URL的查询参数
      const currentQuery = this.$route.query;
      const queryString = Object.keys(currentQuery).length > 0
        ? `?${new URLSearchParams(currentQuery).toString()}`
        : '';

      // 检查是否存在channel参数
      if (this.$route.params.channel) {
        return `/${this.$route.params.channel}${link}${queryString}`;
      }
      return `${link}${queryString}`;
    },
    showToast () {
      console.log('dafdsafdsaf');
      this.showToastMessage = true;

      // 清除之前的定时器
      if (this.toastTimer) {
        clearTimeout(this.toastTimer);
      }

      // 设置新的定时器，2秒后自动关闭
      this.toastTimer = setTimeout(() => {
        this.showToastMessage = false;
      }, 2000);
    }
  },
  beforeDestroy () {
    // 组件销毁前清除定时器
    if (this.toastTimer) {
      clearTimeout(this.toastTimer);
    }
  }
}
</script>

<style lang="scss">
@import '~@/css/variables.scss';
.app-footer {
	background: #000;
	padding: rem(60) rem(180) rem(40);
	width: 100%;
	box-sizing: border-box;
	color: #ffffff;
	&__container {
		width: 100%;
		display: flex;
		flex-direction: column;
		gap: rem(40);
	}
	&__main {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: flex-start;
		gap: rem(40);
	}
	&__info {
		display: flex;
		flex-direction: column;
		gap: rem(16);
	}
	&__logo-box {
		display: flex;
		align-items: center;
		gap: rem(16);
	}
	&__logo-img {
		width: rem(40);
		height: rem(40);
		background: #fff;
		border-radius: 50%;
		padding: rem(4);
	}
	&__logo-text {
		font-family: 'Inter-Black', sans-serif;
		font-size: rem(24);
		font-weight: 900;
	}
	&__desc {
		color: rgba(255, 255, 255, 0.6);
		font-size: rem(12);
		line-height: 1.6;
		margin: 0;
	}
	&__section-title {
		color: #ffffff;
		font-family: 'Inter-SemiBold', sans-serif;
		font-size: rem(12);
		font-weight: 600;
		text-transform: uppercase;
		margin: 0 0 rem(16);
	}
	&__links {
		display: flex;
		gap: rem(40);
		a {
			color: #e2372d;
			text-decoration: none;
			font-size: rem(13);
			&:hover {
				opacity: 0.8;
			}
		}
	}
	&__email {
		color: #e2372d;
		text-decoration: none;
		font-size: rem(13);
		display: block;
	}
	&__social-icons {
		display: flex;
		gap: rem(20);
	}
	&__social-btn {
		width: rem(24);
		height: rem(24);
		img {
			width: 100%;
			height: 100%;
			object-fit: contain;
			filter: brightness(0) invert(1);
		}
	}
	&__divider {
		height: 1px;
		background: rgba(255, 255, 255, 0.1);
		border-bottom: 1px dashed rgba(255, 255, 255, 0.2);
	}
	&__copyright {
		color: rgba(255, 255, 255, 0.3);
		font-size: rem(12);
		margin: 0;
	}
  &__toast {
		position: fixed;
		bottom: 50%;
		transform: translateY(50%);
		left: 50%;
		transform: translateX(-50%);
		padding: rem(10) rem(20);
		background: rgba(0, 0, 0, 0.7);
		color: #fff;
		border-radius: rem(4);
		z-index: 9999;
		font-size: rem(14);
		max-width: rem(200);
		text-align: center;
	}
}

.detect_deviece_mobile {
	.app-footer {
		padding: rem(40) rem(20);
		&__main {
			flex-direction: column;
			gap: rem(40);
		}
		&__links {
			gap: rem(12);
			flex-wrap: wrap;
		}
	}
}
</style>